import { ANDROID_BUNDLE_NAME, IOS_BUNDLE_NAME } from 'constants/externalLinks'

import { externalLinks } from 'utils/constants'
import { firebaseDynamicLinks } from 'utils/firebase/initialize.web'

export const generateDynamicLink = async (url: string): Promise<string> => {
  const { shortLink } = await firebaseDynamicLinks.createLink({
    dynamicLinkInfo: {
      domainUriPrefix: externalLinks.DYNAMIC_LINK_PATH,
      link: `${url}`.toLocaleLowerCase(),
      androidInfo: {
        androidPackageName: ANDROID_BUNDLE_NAME,
      },
      iosInfo: {
        iosBundleId: IOS_BUNDLE_NAME,
      },
    },
  })

  return shortLink
}
